import {type LngLat, type MapMarkerProps, Grid, MapMarker} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React, {type PropsWithChildren, useCallback, useState} from 'react'

import {PointPlacemarkIcon} from '../PointPlacemarkIcon/PointPlacemarkIcon'
import type {PlacemarkType} from '../types'
import bottomArrowSrc from './assets/bottomArrow.svg'
import * as classes from './PointPlacemark.classes'

type Props = MapMarkerProps &
  PropsWithChildren<{
    type: PlacemarkType
  }>

export function PointPlacemark(props: Props): React.ReactElement {
  const {type, children, onDragStart, onDragEnd, draggable, ...otherProps} = props
  const [isDragging, setDragging] = useState(false)

  const dragStartHandler = useCallback(
    (event: LngLat) => {
      setDragging(true)
      onDragStart?.(event)
    },
    [onDragStart],
  )

  const dragEndHandler = useCallback(
    (event: LngLat) => {
      setDragging(false)
      onDragEnd?.(event)
    },
    [onDragEnd],
  )

  return (
    <MapMarker {...otherProps} draggable={draggable} onDragEnd={dragEndHandler} onDragStart={dragStartHandler}>
      <div
        className={clsx(classes.container, {[classes.containerDraggable]: draggable, [classes.dragging]: isDragging})}
      >
        <Grid alignItems="center" className={classes.paper} container>
          <div className={clsx(classes.placeMarkWrap, classes[`placeMarkWrap_${type}`])}>
            <PointPlacemarkIcon type={type}>{children}</PointPlacemarkIcon>
          </div>
        </Grid>
        {draggable ? (
          <div className={clsx(classes.stick, isDragging && classes.stickDragging)} />
        ) : (
          <React.Fragment>
            <img alt="bottomArrow" className={classes.arrow} loading="lazy" src={bottomArrowSrc} />
            <div className={classes.arrowPoint} />
          </React.Fragment>
        )}
      </div>
    </MapMarker>
  )
}
